import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { useAuth } from "../../context/AuthContext";
import { getPayment, processOfflinePayment, initiateSslcommerz } from "../../services/paymentService";

const CASH_LOCATIONS = [
  { value: "venue", label: "Venue-এ, Event এর দিন" },
  { value: "organizer", label: "Event এর আগে, Organizer এর সাথে যোগাযোগ করে" },
];

const Payment = () => {
  const { reference } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [booking, setBooking] = useState(null);
  const [sslAvailable, setSslAvailable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // অফলাইন (cash/bank) পেমেন্টের জন্য প্রয়োজনীয় ফর্ম — backend এ
  // name/phone required, cash হলে cash_location ও required।
  const [offlineMethod, setOfflineMethod] = useState(null); // "cash" | "bank" | null
  const [form, setForm] = useState({ name: "", phone: "", cash_location: "venue" });
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    getPayment(reference)
      .then((data) => {
        setBooking(data.booking);
        setSslAvailable(data.sslcommerz_available);
        setForm((f) => ({
          ...f,
          name: data.booking?.name || user?.name || "",
          phone: data.booking?.phone || "",
        }));
        if (data.booking?.status === "confirmed") {
          navigate(`/my-tickets/${reference}`, { replace: true });
        }
      })
      .catch(() => setError("Booking পাওয়া যায়নি।"))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reference, navigate]);

  const handleOfflineSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    setFieldErrors({});
    try {
      const extra = { name: form.name, phone: form.phone };
      if (offlineMethod === "cash") {
        extra.cash_location = form.cash_location;
      }
      const data = await processOfflinePayment(reference, offlineMethod, extra);
      alert(data.message);
      navigate("/my-bookings");
    } catch (err) {
      setFieldErrors(err?.response?.data?.errors || {});
      setError(err?.response?.data?.message || "সমস্যা হয়েছে, তথ্যগুলো চেক করে আবার চেষ্টা করুন।");
    } finally {
      setSubmitting(false);
    }
  };

  const handleOnline = async () => {
    setSubmitting(true);
    setError("");
    try {
      const data = await initiateSslcommerz(reference);
      window.location.href = data.redirect_url;
    } catch (err) {
      setError(err?.response?.data?.message || "Payment gateway শুরু করা যায়নি।");
      setSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <Header parentMenu="payment" activeMenu="/payment" />
      <SiteBreadcrumb pageTitle="Payment" pageName="Payment" breadcrumbsImg={bannerbg} />

      <section style={{ padding: "80px 0" }}>
        <div className="container" style={{ maxWidth: 560 }}>
          {loading && <p>লোড হচ্ছে...</p>}
          {error && <p style={{ color: "#e6394f" }}>{error}</p>}

          {booking && (
            <>
              <div style={{ border: "1px solid #eee", borderRadius: 8, padding: 20, marginBottom: 24 }}>
                <h3 style={{ marginTop: 0 }}>{booking.event?.title}</h3>
                <p>বুকিং রেফারেন্স: {booking.booking_reference}</p>
                <p>{booking.quantity} × {booking.ticket_type?.name}</p>
                <h4>মোট: ৳{booking.total_price}</h4>
              </div>

              {!offlineMethod && (
                <>
                  <h4>পেমেন্ট মেথড বেছে নিন</h4>
                  <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }}>
                    {sslAvailable && (
                      <button className="thm-btn" onClick={handleOnline} disabled={submitting}>
                        bKash / Nagad / Card দিয়ে পে করুন
                      </button>
                    )}
                    <button
                      className="thm-btn"
                      style={{ background: "#eee", color: "#333" }}
                      onClick={() => setOfflineMethod("cash")}
                      disabled={submitting}
                    >
                      Cash (ইভেন্টে এসে দেবেন)
                    </button>
                    <button
                      className="thm-btn"
                      style={{ background: "#eee", color: "#333" }}
                      onClick={() => setOfflineMethod("bank")}
                      disabled={submitting}
                    >
                      Bank Transfer
                    </button>
                  </div>
                </>
              )}

              {offlineMethod && (
                <form onSubmit={handleOfflineSubmit} style={{ marginTop: 16 }}>
                  <h4>{offlineMethod === "cash" ? "Cash পেমেন্ট" : "Bank Transfer"} — আপনার তথ্য দিন</h4>

                  <div style={{ marginBottom: 14 }}>
                    <label>আপনার নাম</label>
                    <input
                      type="text"
                      value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      required
                      style={{ width: "100%", padding: 10, marginTop: 4 }}
                    />
                    {fieldErrors.name && <small style={{ color: "#e6394f" }}>{fieldErrors.name[0]}</small>}
                  </div>

                  <div style={{ marginBottom: 14 }}>
                    <label>ফোন নাম্বার</label>
                    <input
                      type="tel"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      required
                      style={{ width: "100%", padding: 10, marginTop: 4 }}
                    />
                    {fieldErrors.phone && <small style={{ color: "#e6394f" }}>{fieldErrors.phone[0]}</small>}
                  </div>

                  {offlineMethod === "cash" && (
                    <div style={{ marginBottom: 14 }}>
                      <label>কোথায় Cash দেবেন</label>
                      <select
                        value={form.cash_location}
                        onChange={(e) => setForm({ ...form, cash_location: e.target.value })}
                        style={{ width: "100%", padding: 10, marginTop: 4 }}
                      >
                        {CASH_LOCATIONS.map((loc) => (
                          <option key={loc.value} value={loc.value}>{loc.label}</option>
                        ))}
                      </select>
                      {fieldErrors.cash_location && (
                        <small style={{ color: "#e6394f" }}>{fieldErrors.cash_location[0]}</small>
                      )}
                    </div>
                  )}

                  <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
                    <button type="submit" className="thm-btn" disabled={submitting}>
                      {submitting ? "সেভ হচ্ছে..." : "নিশ্চিত করুন"}
                    </button>
                    <button
                      type="button"
                      className="thm-btn"
                      style={{ background: "#eee", color: "#333" }}
                      onClick={() => setOfflineMethod(null)}
                      disabled={submitting}
                    >
                      পিছনে যান
                    </button>
                  </div>
                </form>
              )}
            </>
          )}
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Payment;
